import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { claimsApiService } from '@/services/claims-api.service'
import { claimExcessApiService } from '@/services/claimExcess-api.service'
import { gadgetApiService } from '@/services/gadget-api.service'
import { pipelineApiService } from '@/services/pipeline-api.service'
import { formApiService } from '@/services/form-api.service'
import { repairOptionApiService } from '@/services/repairOption-api.service'
import { salesApiService } from '@/services/sales-api.service'

import notificationStore from '@/NotificationStore.js'
import formUser from '@/store/formUser.js'
import reports from '@/store/reports.js'
import messageStore from './store/messageStore'
import recentClaimStore from './store/recentClaimsStore'
import appSettings from './store/appSettings'
import validations from './store/validations'
import custPayments from './store/CustomerPayments'
import suplPayments from './store/SupplierPaymentsStore'
import claimPayments from './store/ClaimPaymentsStore'
import checkmend from './store/checkmend.js'
import claimStatus from './store/claimStatus.js'

import mutations from './store/mutations.js'
import getters from './store/getters.js'
import actions from './store/actions.js'

export default new Vuex.Store({
    modules: {
        notificationModule: notificationStore,
        formUser: formUser,
        reports: reports,
        messageStore: messageStore,
        recentClaimStore: recentClaimStore,
        appSettings: appSettings,
        validations: validations,
        custPayments: custPayments,
        suplPayments: suplPayments,
        claimPayments: claimPayments,
        checkmend: checkmend,
        claimStatus: claimStatus
    },
    state: {
        claimsList: [],
        pagenation: null,
        selectedClaim: null,
        selectedClaimIndex: 0,
        documentTypes: [],
        declinationReasons: [],
        manualStatuses: [],
        resellers: [],
        underwriters: [],
        incidentTypes: [],
        repairProviders: [],
        repairOptionTypes: [],
        repairOptionInstructions: [],
        repairOptionMatrix: [],
        repairOptionWebDisplay: [],
        selectedOptionInstructions: null,
        formUserList: [],
        loading: false,
        emailPreview: { messageHtml: null, messageText: null },
        developerExceptions: [],
        routes: [
            {
                routeName: 'claimsBucket0',
                approveRoute: '/buckets/bucket0/approve'
            },
            {
                routeName: 'claimQuickApprove0',
                popoutUrl: '/buckets/bucket0/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket1',
                approveRoute: '/buckets/bucket1/approve'
            },
            {
                routeName: 'claimQuickApprove1',
                popoutUrl: '/buckets/bucket1/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucketPoliceFed',
                approveRoute: '/buckets/policefed/approve'
            },
            {
                routeName: 'claimQuickApprove1',
                popoutUrl: '/buckets/bucket1/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket2',
                approveRoute: '/buckets/bucket2/approve'
            },
            {
                routeName: 'claimQuickApprove2',
                popoutUrl: '/buckets/bucket2/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket3',
                approveRoute: '/buckets/bucket3/approve'
            },
            {
                routeName: 'claimQuickApprove3',
                popoutUrl: '/buckets/bucket3/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket4',
                approveRoute: '/buckets/bucket4/approve'
            },
            {
                routeName: 'claimQuickApprove4',
                popoutUrl: '/buckets/bucket4/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket5',
                approveRoute: '/buckets/bucket5/approve'
            },
            {
                routeName: 'claimQuickApprove5',
                popoutUrl: '/buckets/bucket5/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket6',
                approveRoute: '/buckets/bucket6/approve'
            },
            {
                routeName: 'claimQuickApprove6',
                popoutUrl: '/buckets/bucket6/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket7',
                approveRoute: '/buckets/bucket7/approve'
            },
            {
                routeName: 'claimQuickApprove7',
                popoutUrl: '/buckets/bucket7/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket8',
                approveRoute: '/buckets/bucket8/approve'
            },
            {
                routeName: 'claimQuickApprove8',
                popoutUrl: '/buckets/bucket8/approve/popout/?sidebar=false'
            },
            {
                routeName: 'TaskHistory',
                approveRoute: '/taskHistory/view'
            },
            {
                routeName: 'TaskHistoryView',
                popoutUrl: '/taskHistory/view/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket9',
                approveRoute: '/buckets/bucket9/approve'
            },
            {
                routeName: 'claimQuickApprove9',
                popoutUrl: '/buckets/bucket9/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimsBucket10',
                approveRoute: '/buckets/bucket10/approve'
            },
            {
                routeName: 'claimQuickApprove10',
                popoutUrl: '/buckets/bucket10/approve/popout/?sidebar=false'
            },
            {
                routeName: 'claimUnreadMessages',
                approveRoute: '/buckets/claimunreadmessages/approve'
            },
            {
                routeName: 'claimUnreadMessagesApprove1',
                popoutUrl: '/buckets/claimunreadmessages/approve/popout/?sidebar=false'
            },
            {
                routeName: 'settlementoptiontasks',
                approveRoute: '/buckets/settlementoptiontasks/approve'
            },
            {
                routeName: 'settlementoptiontasksApprove',
                popoutUrl: '/buckets/settlementoptiontasks/approve/popout/?sidebar=false'
            },
        ],
        pipelines: [],
        pipelineTypes: [],
        resellerPipelines: [],
        selectedResellerPipeline: null,
        pipelineRules: [],
        selectedPipeline: {},
        selectedPipelineRule: {},
        ruleParameters: [],
        ruleComponents: [],
        taskHistoryList: [],
        taskTypes: [],
        taskTypesOutstanding: [],
        deviceTypes: [],
        deviceMakes: [],
        salesDocumentUploads: [],
        gadgetOptionsPreview: null,
        emailTemplates: null,
        manDeviceRepairPreConfigItems: null,
        claimDocumentsLoading: false
    },
    mutations: mutations,
    actions: {
        ...actions,
        resetDeveloperExceptions({ commit }) {
            commit('clearDeveloperExceptions')
        },
        resetEmailPreview({ commit }) {
            commit('setEmailPreview', { messageHtml: null, messageText: null })
        },
        fetchClaimsListPagenated({ commit }, payload) {
            commit('setLoading', true)
            commit('setSelectedClaim', null)
            commit('setClaimsList', null)
            //commit('setPagenation', null)
            claimsApiService.getClaimsFilterPagenated(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchTaskHistoryListPagenated({ commit }, payload) {
            commit('setLoading', true)
            commit('setTaskHistoryList', null)
            commit('setSelectedClaim', null)
            commit('setClaimsList', null)
            claimsApiService.getTaskHistoryFilterPagenated(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setTaskHistoryList', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchClaimsLatestDocUploadListPagenated({ commit }, payload) {
            commit('setLoading', true)
            commit('setSelectedClaim', null)
            commit('setClaimsList', null)
            //commit('setPagenation', null)
            claimsApiService.getClaimsLatestUploadDocsFilterPagenated(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchClaimsExcessCardPaymentsFilterPagenated({ commit }, payload) {
            commit('setLoading', true)
            commit('setSelectedClaim', null)
            commit('setClaimsList', null)
            //commit('setPagenation', null)
            claimsApiService.getClaimsExcessCardPaymentsFilterPagenated(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchClaimsSelectedRepairOptionsFilterPagenated({ commit }, payload) {
            commit('setLoading', true)
            commit('setSelectedClaim', null)
            commit('setClaimsList', null)
            //commit('setPagenation', null)
            claimsApiService.getClaimsSelectedRepairOptionsFilterPagenated(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchSelectedClaim({ commit }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.getSelectedClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setSelectedClaim', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchSelectedClaimEx({ getters, dispatch, commit }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.getSelectedClaim(payload)
                .then((response) => {
                    let { data } = response.data

                    dispatch('loadSelectedClaimAncillaries', data)

                    //commit('setSelectedClaim', data)
                    //let { number, claimId, insuranceLineId, policyId, userId } = data
                    //dispatch('fetchPolicyClaim',{ insuranceLineId, policyId })
                    //dispatch('fetchUserClaim', { userId })
                    //dispatch('fetchTaskTypesOutstanding',claimId)

                    //dispatch('fetchSalesDocumentUploads', number)
                    //dispatch('messageStore/fetchAttachmentsForClaim', { claimId })

                    //if (getters.selectedClaimPolicyImported) {
                    //    let { resellerId, claimantDetails } = data
                    //    let { email } = claimantDetails
                    //    dispatch('formUser/checkUserExists', { resellerId, emailAddress: email })
                    //}
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        loadSelectedClaimAncillaries({ getters, dispatch, commit }, payload) {

            let data = payload
            commit('setSelectedClaim', data)

            let { quoteId, number, claimId, insuranceLineId, policyId, userId } = data
            dispatch('fetchPolicyClaim', { insuranceLineId, policyId })
            dispatch('fetchUserClaim', { userId })
            dispatch('fetchTaskTypesOutstanding', claimId)

            let salesId = quoteId !== null ? quoteId : number
            dispatch('fetchSalesDocumentUploads', salesId)
            dispatch('messageStore/fetchAttachmentsForClaim', { claimId })

            try {
                if (getters.selectedClaimPolicyImported) {
                    let { resellerId, claimantDetails } = data
                    let { email } = claimantDetails
                    dispatch('formUser/checkUserExists', { resellerId, emailAddress: email })
                }
            }
            catch (err) {
                console.log('loadSelectedClaimAncillaries: ', err)
            }
        },
        setSelectedClaimIndex({ commit }, payload) {
            commit('setSelectedClaimIndex', payload)
        },
        refreshClaimantForClaim({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.refreshClaimant(payload)
                .then((response) => {

                    let { data } = response.data

                    dispatch('loadSelectedClaimAncillaries', data)

                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                    dispatch('notificationModule/toast', 'Successfully refreshed Claimant details')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to refresh Claimant details')
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchDocumentTypes({ commit }) {
            commit('setDocumentTypes', [])
            commit('setLoading', true)
            claimsApiService.getDocumentTypes()
                .then(response => {
                    let { data } = response.data
                    commit('setDocumentTypes', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchDeclinationReasons({ commit }) {
            commit('setDeclinationReasons', [])
            //commit('setLoading', true)
            claimsApiService.getDeclinationReasons()
                .then(response => {
                    let { data } = response.data
                    commit('setDeclinationReasons', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { /*commit('setLoading', false)*/ })
        },
        fetchManualStatuses({ commit }) {
            commit('setManualStatuses', [])
            //commit('setLoading', true)
            claimsApiService.getManualStatuses()
                .then(response => {
                    let { data } = response.data
                    commit('setManualStatuses', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { /*commit('setLoading', false)*/ })
        },
        fetchResellers({ commit }) {
            commit('setResellers', [])
            //commit('setLoading', true)
            claimsApiService.getResellers()
                .then(response => {
                    let { data } = response.data
                    commit('setResellers', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { /*commit('setLoading', false)*/ })
        },
        fetchUnderwriters({ commit }) {
            commit('setUnderwriters', [])
            //commit('setLoading', true)
            claimsApiService.getUnderwriters()
                .then(response => {
                    let { data } = response.data
                    commit('setUnderwriters', data)
                })
                .finally(() => { /*commit('setLoading', false)*/ })
        },
        fetchTaskTypes({ commit }) {
            commit('setTaskTypes', [])
            commit('setLoading', true)
            claimsApiService.getTaskTypes()
                .then(response => {
                    let { data } = response.data
                    commit('setTaskTypes', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchTaskTypesOutstanding({ commit }, payload) {
            commit('setTaskTypesOutstanding', [])
            commit('setLoading', true)
            claimsApiService.getTaskTypesOutstanding(payload)
                .then(response => {
                    let { data } = response.data
                    commit('setTaskTypesOutstanding', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchIncidentTypes({ commit }) {
            commit('setIncidentTypes', [])
            //commit('setLoading', true)
            claimsApiService.getIncidentTypes()
                .then(response => {
                    let { data } = response.data
                    commit('setIncidentTypes', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { /*commit('setLoading', false)*/ })
        },
        fetchRepairProviders({ commit }) {
            commit('setRepairProviders', [])
            //commit('setLoading', true)
            claimsApiService.getRepairProviders()
                .then(response => {
                    let { data } = response.data
                    commit('setRepairProviders', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { /*commit('setLoading', false)*/ })
        },
        fetchRepairOptionWebDisplay({ commit }) {
            commit('setRepairOptionWebDisplay', [])
            //commit('setLoading', true)
            repairOptionApiService.getWebDisplayItems()
                .then(response => {
                    let { data } = response.data
                    commit('setRepairOptionWebDisplay', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchRepairOptionTypes({ commit }) {
            commit('setRepairOptionTypes', [])
            //commit('setLoading', true)
            claimsApiService.getRepairOptionTypes()
                .then(response => {
                    let { data } = response.data
                    commit('setRepairOptionTypes', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { /*commit('setLoading', false)*/ })
        },
        clearClaimsList({ commit, state }) {
            commit('setClaimsList', [])
            if (state.pagenation) {
                let { pageSize } = state.pagenation
                commit('setPagenation', { pageSize, pageNumber: 1 })
            } else {
                commit('setPagenation', { pageSize: 5, pageNumber: 1 })
            }
        },
        clearSelectedClaim({ commit }) {
            commit('setSelectedClaim', null)
        },
        updateClaimRelatedRef({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.setRelatedReference(payload)
                .then((response) => {
                    let { data } = response.data

                    dispatch('loadSelectedClaimAncillaries', data)

                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                    dispatch('notificationModule/toast', 'Successfully updated Claim details')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to update Claim details')
                })
                .finally(() => { commit('setLoading', false) })
        },
        updateClaims({ commit, dispatch }, payload) {
            commit('setLoading', true)
            commit('setClaimsList', null)
            claimsApiService.updateClaims(payload)
                .then((response) => {
                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                    dispatch('notificationModule/toast', 'Successfully updated Claim details')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to update Claim details')
                })
                .finally(() => { commit('setLoading', false) })
        },
        updateClaimTaskFlags({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.setTaskFlags(payload)
                .then((response) => {
                    let { data } = response.data

                    dispatch('loadSelectedClaimAncillaries', data)
                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                    dispatch('notificationModule/toast', 'Successfully updated Task flag details')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to update Task flag details')
                })
                .finally(() => { commit('setLoading', false) })
        },
        updateClaimsTaskFlags({ commit, dispatch }, payload) {
            commit('setLoading', true)
            commit('setClaimsList', null)
            claimsApiService.setTaskFlagsForClaims(payload)
                .then((response) => {
                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                    dispatch('notificationModule/toast', 'Successfully updated Task flag details')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to update Task flag details')
                })
                .finally(() => { commit('setLoading', false) })
        },
        updateClaimsDocTaskFlags({ commit, dispatch }, payload) {
            commit('setLoading', true)
            commit('setClaimsList', null)
            claimsApiService.setTaskFlagsForClaimsDoc(payload)
                .then((response) => {
                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                    dispatch('notificationModule/toast', 'Successfully updated Task flag details')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to update Task flag details')
                })
                .finally(() => { commit('setLoading', false) })
        },
        updateClaimsPayTaskFlags({ commit, dispatch }, payload) {
            commit('setLoading', true)
            commit('setClaimsList', null)
            claimsApiService.setTaskFlagsForClaimsPay(payload)
                .then((response) => {
                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                    dispatch('notificationModule/toast', 'Successfully updated Task flag details')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to update Task flag details')
                })
                .finally(() => { commit('setLoading', false) })
        },
        updateClaimsRepTaskFlags({ commit, dispatch }, payload) {
            commit('setLoading', true)
            commit('setClaimsList', null)
            claimsApiService.setTaskFlagsForClaimsRep(payload)
                .then((response) => {
                    let { data, pagenation } = response.data
                    commit('setClaimsList', data)
                    commit('setPagenation', pagenation)
                    dispatch('notificationModule/toast', 'Successfully updated Task flag details')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to update Task flag details')
                })
                .finally(() => { commit('setLoading', false) })
        },
        approveClaim({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.approveClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    dispatch('loadSelectedClaimAncillaries', data)

                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                    dispatch('notificationModule/toast', 'Successfully sent Claim approved email')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to send Claim approved email')
                })
                .finally(() => { commit('setLoading', false) })
        },
        approveClaimPreview({ commit, dispatch }, payload) {
            dispatch('resetEmailPreview')
            commit('setLoading', true)
            claimsApiService.approveClaimPreview(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setEmailPreview', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        declineClaim({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.declineClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    dispatch('loadSelectedClaimAncillaries', data)

                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                    dispatch('notificationModule/toast', 'Successfully sent Claim declined email')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Faile to send Claim declined email')
                })
                .finally(() => { commit('setLoading', false) })
        },
        declineClaimEmailPreview({ commit, dispatch }, payload) {
            dispatch('resetEmailPreview')
            commit('setLoading', true)
            claimsApiService.declineClaimEmailPreview(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setEmailPreview', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        requestMoreDocs({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.requestMoreDocs(payload)
                .then((response) => {
                    let { data } = response.data
                    dispatch('loadSelectedClaimAncillaries', data)

                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        addClaimNote({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.addClaimNote(payload)
                .then((response) => {
                    let { data } = response.data
                    dispatch('loadSelectedClaimAncillaries', data)

                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                    dispatch('notificationModule/toast', 'Successfully added Claim note')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to add Claim note')
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchNotesForClaim({ commit }, payload) {
            commit('setLoading', true)
            claimsApiService.getNotesForClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('addClaimNote', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        addClaimNote2({ commit, dispatch }, payload) {
            commit('setLoading', true)
            claimsApiService.addClaimNote2(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('addClaimNote', data)
                    dispatch('notificationModule/toast', 'Successfully added Claim note')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to add Claim note')
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchPipelines({ commit }, payload) {
            commit('setLoading', true)
            commit('setPipelines', null)
            pipelineApiService.getPipelines(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setPipelines', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchPipelineTypes({ commit }, payload) {
            commit('setLoading', true)
            commit('setPipelineTypes', null)
            pipelineApiService.getPipelineTypes(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setPipelineTypes', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchResellerPipelines({ commit }, payload) {
            commit('setLoading', true)
            commit('setResellerPipelines', null)
            pipelineApiService.getResellerPipelines(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setResellerPipelines', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchPipelineRules({ commit }, payload) {
            commit('setLoading', true)
            commit('setPipelineRules', null)
            pipelineApiService.getPipelineRules(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setPipelineRules', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        setSelectedResellerPipeline({ commit }, payload) {
            commit('setSelectedResellerPipeline', payload)
        },
        setSelectedPipeline({ commit }, payload) {
            commit('setSelectedPipeline', payload)
        },
        setSelectedRule({ commit }, payload) {
            commit('setSelectedRule', payload)
        },
        fetchRuleParameters({ commit }, payload) {
            commit('setLoading', true)
            commit('setRuleParameters', null)
            pipelineApiService.getRuleParameters(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setRuleParameters', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchRuleComponents({ commit }, payload) {
            commit('setLoading', true)
            commit('setRuleComponents', null)
            pipelineApiService.getRuleComponents(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setRuleComponents', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        addPipeline({ commit, dispatch }, payload) {
            commit('setLoading', true)
            pipelineApiService.addPipeline(payload)
                .then(() => {

                    //let { data, pagenation } = response.data
                    dispatch('fetchPipelines')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        addPipelineRule({ commit, dispatch }, payload) {
            commit('setLoading', true)
            pipelineApiService.addPipelineRule(payload)
                .then(() => {

                    //let { data, pagenation } = response.data
                    let { pipelineId } = payload
                    dispatch('fetchPipelineRules', { pipelineId })
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        addResellerPipeline({ commit, dispatch }, payload) {
            commit('setLoading', true)
            pipelineApiService.addResellerPipeline(payload)
                .then(() => {

                    //let { data, pagenation } = response.data
                    dispatch('fetchResellerPipelines', {})
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        addRuleParameter({ commit, dispatch }, payload) {
            commit('setLoading', true)
            pipelineApiService.addRuleParameter(payload)
                .then(() => {

                    //let { data, pagenation } = response.data
                    let { resellerPipelineId, ruleId } = payload
                    dispatch('fetchRuleParameters', { resellerPipelineId, ruleId })
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        updateRuleParameter({ commit, dispatch }, payload) {
            commit('setLoading', true)
            pipelineApiService.updateRuleParameter(payload)
                .then((response) => {

                    let { data } = response.data
                    let { resellerPipelineId, ruleId } = data
                    dispatch('fetchRuleParameters', { resellerPipelineId, ruleId })
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        addRuleComponent({ commit, dispatch }, payload) {
            commit('setLoading', true)
            pipelineApiService.addRuleComponent(payload)
                .then(() => {

                    //let { data, pagenation } = response.data
                    dispatch('fetchRuleComponents')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        requestMoreDocsEmailPreview({ commit, dispatch }, payload) {
            dispatch('resetEmailPreview')
            commit('setLoading', true)
            claimsApiService.requestMoreDocsEmailPreview(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setEmailPreview', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        otherEmailPreview({ commit, dispatch }, payload) {
            dispatch('resetEmailPreview')
            commit('setLoading', true)
            claimsApiService.otherEmailPreview(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setEmailPreview', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        sendOtherEmail({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.otherEmail(payload)
                .then((response) => {
                    let { data } = response.data
                    dispatch('loadSelectedClaimAncillaries', data)

                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                    dispatch('notificationModule/toast', 'Successfully sent email')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to send email')
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchFormUserListPagenated({ commit }, payload) {
            commit('setLoading', true)
            commit('setFormUserList', null)
            formApiService.getFormUserFilterPagenated(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setFormUserList', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        resetRepairOptionInstructions({ commit }) {
            commit('setRepairOptionInstructions', [])
        },
        fetchRepairOptionInstructions({ commit, dispatch }, payload) {
            commit('setLoading', true)
            dispatch('resetRepairOptionInstructions')
            repairOptionApiService.getInstructionFilterPagenated(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setRepairOptionInstructions', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        setSelectedOptionInstructions({ commit }, payload) {
            commit('setSelectedOptionInstructions', payload)
        },
        fetchRepairOptionMatrix({ commit }, payload) {
            commit('setLoading', true)
            commit('setRepairOptionMatrix', [])
            repairOptionApiService.getMatrixFilterPagenated(payload)
                .then((response) => {

                    let { data, pagenation } = response.data
                    commit('setRepairOptionMatrix', data)
                    commit('setPagenation', pagenation)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchDeviceTypes({ commit }) {
            commit('setLoading', true)
            commit('setDeviceTypes', [])
            repairOptionApiService.getDeviceTypes()
                .then((response) => {

                    let { data, } = response.data
                    commit('setDeviceTypes', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchDeviceMakes({ commit }) {
            commit('setLoading', true)
            commit('setDeviceMakes', [])
            repairOptionApiService.getDeviceMakes()
                .then((response) => {

                    let { data, } = response.data
                    commit('setDeviceMakes', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchEmailHistoryClaim({ commit }, payload) {
            commit('setLoading', true)
            claimsApiService.getEmailHistoryForClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setClaimEmailHistory', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchStatusHistoryClaim({ commit }, payload) {
            commit('setLoading', true)
            claimsApiService.getStatusHistoryForClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setClaimStatusHistory', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchPipelineRunHistoryClaim({ commit }, payload) {
            commit('setLoading', true)
            claimsApiService.getPipelineRunHistoryForClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setClaimPipelineRunHistory', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchPipelineRunHistoryClaimV2({ commit }, payload) {
            commit('setLoading', true)
            return new Promise((resolve, reject) => {

                claimsApiService.getPipelineRunHistoryForClaim(payload)
                    .then((response) => {
                        let { data } = response.data
                        commit('setClaimPipelineRunHistory', data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit('addDeveloperException', error)
                        reject(error)
                    })
                    .finally(() => { commit('setLoading', false) })
            })
        },
        fetchSelectedRepairOptionsClaim({ commit }, payload) {
            commit('setLoading', true)
            claimsApiService.getClaimsSelectedRepairOptionsForClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setClaimSelectedRepairOptions', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        cancelSelectedOption({ commit, dispatch }, payload) {
            commit('setLoading', true)
            return new Promise((resolve, reject) => {
                repairOptionApiService.cancelSelectedOption(payload)
                    .then((response) => {
                        let { data, messages } = response.data
                        if (data) {
                            dispatch('notificationModule/toast', 'Successfully cancelled option!')
                            resolve(data)
                        } else {
                            if (messages != null && messages.length > 0) {
                                let msg = messages[0].body
                                dispatch('notificationModule/toast', msg)
                                commit('addDeveloperException', msg)
                            }
                            if (reject)
                                reject(messages)
                        }
                        
                        //commit('setClaimSelectedRepairOptions', data)
                    })
                    .catch((error) => {
                        commit('addDeveloperException', error)
                        if (reject)
                            reject(error)
                    })
                    .finally(() => { commit('setLoading', false) })
            })
        },
        addSelectedOptionNote({ commit, dispatch }, payload) {
            commit('setLoading', true)
            return new Promise((resolve, reject) => {
                repairOptionApiService.addSelectedOptionNote(payload)
                    .then((response) => {
                        let { data, messages } = response.data
                        if (data) {
                            dispatch('notificationModule/toast', 'Successfully added note!')
                            resolve(data)
                        } else {
                            if (messages != null && messages.length > 0) {
                                for (var i = 0; i < messages.length; i++) {
                                    let msg = messages[i].body
                                    dispatch('notificationModule/toast', msg)
                                    commit('addDeveloperException', msg)
                                }
                            }
                            if (reject)
                                reject(messages)
                        }
                    })
                    .catch((error) => {
                        commit('addDeveloperException', error)
                        dispatch('notificationModule/toast', `Error attemting to add note! [${error}]`)
                        if (reject)
                            reject(error)
                    })
                    .finally(() => { commit('setLoading', false) })
            })
        },
        //fetchExcessPaymentsClaim({ commit }, payload) {
        //    commit('setLoading', true)
        //    claimsApiService.getClaimsExcessCardPaymentsFilterPagenated(payload)
        //        .then((response) => {
        //            let { data } = response.data
        //            commit('setClaimExcessPayments', data)
        //        })
        //        .catch((error) => {
        //            commit('addDeveloperException', error)
        //        })
        //        .finally(() => { commit('setLoading', false) })
        //},
        fetchDocumentsClaim({ commit }, payload) {
            commit('setLoading', true)
            claimsApiService.getDocumentsForClaim(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setClaimDocuments', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        addClaimManExcessCalc({ commit, dispatch }, payload) {
            commit('setLoading', true)
            let func

            if (payload.gadgetId) {
                func = claimExcessApiService.addManExcessCalcGadget
            } else {
                func = claimExcessApiService.addManExcessCalcClaim
            }

            func(payload)
                .then((response) => {
                    let { data, messages } = response.data
                    commit('setClaimExcessCalculations', data)
                    if (messages && messages.length > 0) {
                        dispatch('notificationModule/toast', messages[0].body)
                    } else {
                        dispatch('notificationModule/toast', 'Successfully added Claim Excess Calculation')
                    }
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to add Claim Excess Calculation')
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchPolicyClaim({ commit }, payload) {
            commit('setLoading', true)
            let { insuranceLineId, policyId } = payload

            switch (insuranceLineId) {
                case 1:
                    claimsApiService.getGadgetPolicyForClaim(policyId)
                        .then((response) => {
                            let { data } = response.data
                            commit('setClaimPolicy', data)
                        })
                        .catch((error) => {
                            commit('addDeveloperException', error)
                        })
                        .finally(() => { commit('setLoading', false) })
                    break;
                case 2:
                    claimsApiService.getTigaPolicyForClaim(policyId)
                        .then((response) => {
                            let { data } = response.data
                            commit('setClaimPolicy', data)
                        })
                        .catch((error) => {
                            commit('addDeveloperException', error)
                        })
                        .finally(() => { commit('setLoading', false) })
                    break;
                case 3:
                    claimsApiService.getTigaPolicyForClaim(policyId)
                        .then((response) => {
                            let { data } = response.data
                            commit('setClaimPolicy', data)
                        })
                        .catch((error) => {
                            commit('addDeveloperException', error)
                        })
                        .finally(() => { commit('setLoading', false) })
                    break;
                case 5:
                    claimsApiService.getPolFedPolicyForClaim(policyId)
                        .then((response) => {
                            let { data } = response.data
                            commit('setClaimPolicy', data)
                        })
                        .catch((error) => {
                            commit('addDeveloperException', error)
                        })
                        .finally(() => { commit('setLoading', false) })
                    break;
                default:
                // code block
            }

        },
        fetchUserClaim({ commit }, payload) {
            commit('setLoading', true)
            let { userId } = payload

            if (userId) {
                formApiService.getFormUser(userId)
                    .then((response) => {
                        let { data } = response.data
                        commit('setClaimUser', data)
                    })
                    .catch((error) => {
                        commit('addDeveloperException', error)
                    })
                    .finally(() => { commit('setLoading', false) })
            }
        },
        fetchUserLoginHistoryClaim({ commit }, payload) {
            commit('setLoading', true)
            let { userId, pageNumber } = payload

            if (userId) {
                formApiService.getFormUserLoginHistoryEx(userId,pageNumber)
                    .then((response) => {
                        let { data } = response.data
                        commit('setClaimUserLoginHistory', data)
                    })
                    .catch((error) => {
                        commit('addDeveloperException', error)
                    })
                    .finally(() => { commit('setLoading', false) })
            }
        },
        fetchManDeviceRepairPreConfigItems({ commit }, payload) {
            //commit('setLoading', true)
            commit('setManDeviceRepairPreConfigItems', null)
            repairOptionApiService.getManDeviceRepairPreConfigItems(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setManDeviceRepairPreConfigItems', data)
                })
                .catch((error) => {
                    console.error(error)
                })
        },
        resetOptionsPreviewForGadget({ commit }) {
           commit('setClaimGadgetOptionsPreview', null)
        },
        addManualOptionForGadget({ commit, dispatch }, payload) {
            //commit('setLoading', true)
            repairOptionApiService.addManualOptionForGadget(payload)
                .then((response) => {
                    let { data, messages } = response.data
                    dispatch('fetchOptionsPreviewForGadget', payload.gadgetWebReference)
                    if (messages && messages.length > 0) {
                        dispatch('notificationModule/toast', messages[0].body)
                    } else {
                        dispatch('notificationModule/toast', 'Successfully added manual option')
                    }
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to add manual option')
                })
                .finally(() => { commit('setLoading', false) })
        },
        addManualOptionForGadgetFromPreConfig({ commit, dispatch }, payload) {
            repairOptionApiService.addManualOptionForGadgetFromPreConfig(payload)
                .then((response) => {
                    let { data, messages } = response.data
                    dispatch('fetchOptionsPreviewForGadget', payload.gadgetWebReference)
                    if (messages && messages.length > 0) {
                        dispatch('notificationModule/toast', messages[0].body)
                    } else {
                        dispatch('notificationModule/toast', 'Successfully added manual option')
                    }
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to add manual option')
                })
                .finally(() => { commit('setLoading', false) })
        },
        addManualOptionForGadgetFromSys({ commit, dispatch }, payload) {
            repairOptionApiService.addManualOptionForGadgetFromSys(payload)
                .then((response) => {
                    let { data, messages } = response.data
                    dispatch('fetchOptionsPreviewForGadget', payload.gadgetWebReference)
                    if (messages && messages.length > 0) {
                        dispatch('notificationModule/toast', messages[0].body)
                    } else {
                        dispatch('notificationModule/toast', 'Successfully added manual option')
                    }
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to add manual option')
                })
                .finally(() => { commit('setLoading', false) })
        },
        delManualOption({ commit, dispatch }, payload) {
            repairOptionApiService.delManualOption(payload.optionId)
                .then((response) => {
                    let { data, messages } = response.data
                    dispatch('fetchOptionsPreviewForGadget', payload.gadgetWebReference)
                    if (messages && messages.length > 0) {
                        dispatch('notificationModule/toast', messages[0].body)
                    } else {
                        dispatch('notificationModule/toast', 'Successfully deleted manual option')
                    }
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to delete manual option')
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchSalesDocumentUploads({ commit }, payload) {
            commit('setLoading', true)
            commit('setSalesDocumentUploads', null)
            salesApiService.getDocumentsForQuote(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setSalesDocumentUploads', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        updateCardPaymentStatus({ commit, dispatch }, payload) {
            commit('setLoading', true)
            claimExcessApiService.updateExcessPaymentStatus(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setClaimExcessPayments', data)
                    dispatch('notificationModule/toast', 'Successfully updated Card Payment Status')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to update Card Payment Status')
                })
                .finally(() => { commit('setLoading', false) })
        },
        disableGadgetForClaim({ commit, dispatch }, payload) {
            commit('setLoading', true)
            gadgetApiService.setDisabled(payload)
                .then((response) => {
                    let { data } = response.data
                    if (data) {
                        if (data.messages && Array.isArray(data.messages) && data.messages.length > 0) {
                            dispatch('notificationModule/toast', 'Failed to remove gadget from claim.')
                            data.messages.forEach(m => commit('addDeveloperException', m))
                        }
                        commit('selectedClaimAddReplaceGadget', data)
                        dispatch('notificationModule/toast', 'Successfully removed gadget from claim.')
                    }
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to remove gadget from claim.')
                })
                .finally(() => { commit('setLoading', false) })
        },
        claimPaymentEmailPreview({ commit, dispatch }, payload) {
            dispatch('resetEmailPreview')
            commit('setLoading', true)
            claimsApiService.claimPaymentEmailPreview(payload)
                .then((response) => {
                    let { data } = response.data
                    commit('setEmailPreview', data)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
        },
        sendClaimPaymentEmail({ commit, dispatch }, payload) {
            commit('setSelectedClaim', null)
            commit('setLoading', true)
            claimsApiService.claimPaymentEmail(payload)
                .then((response) => {
                    let { data } = response.data
                    dispatch('loadSelectedClaimAncillaries', data)

                    //let { data } = response.data
                    //commit('setSelectedClaim', data)
                    dispatch('notificationModule/toast', 'Successfully sent email')
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                    dispatch('notificationModule/toast', 'Failed to send email')
                })
                .finally(() => { commit('setLoading', false) })
        },
        fetchStatuses({ commit }) {
            return new Promise((resolve, reject) => {
                claimsApiService
                    .getStatuses()
                    .then(response => {
                        let { data: apiResponse } = response
                        resolve(apiResponse);
                    })
                    .catch(error => {
                        commit('addDeveloperException', error)
                        reject(error);
                    })
            });
        },
        updateClaimIncidentDate({ commit }, payload) {
            console.log(payload);
            claimsApiService.updateIncidentDate(payload)
                .then(response => {
                    if (response.data.code == 200) {
                        commit('setIncidentDate', new Date(payload.incidentDate).toLocaleDateString(undefined, { weekday: undefined, year: 'numeric', month: 'long', day: 'numeric' }))
                    }
                    console.log(response);
                }).catch(error => {
                    console.log(error);
                })
        }  
    },
    getters: getters

  
})
